import { toCamelCase } from './toCamelCase'
import { isArray } from './validations'

export interface IGetValueResult {
  key: string
  value: unknown
}

/**
 * Get item child value of an object with a string selector
 * @param selector string with the path of the child, it must start with 'item.'
 * @param data : object data
 */
export const getValue = <T>(selector: string, data: T): IGetValueResult => {
  const keys = selector?.split('.') || []

  if (keys.length === 1) {
    return {
      key: toCamelCase(selector),
      value: selector
    }
  }

  keys.shift() // remove the first selector "item."
  const newValue = keys.reduce((value: unknown, key: string) => {
    if (typeof value === 'object') {
      return value?.[key as keyof typeof value]
    }
    return value
  }, data)

  return {
    key: keys[keys.length - 1],
    value: newValue
  }
}

/**
 * Get all values of an object with an array of string selectors
 * @param selectors
 * @param data
 */
export const getAllValues = <T>(
  selectors: string[],
  data: T
): IGetValueResult[] => {
  const values =
    selectors?.map((selector) => {
      const result = getValue(selector, data)
      const { key, value } = result

      if (isArray(value)) {
        return value.map((childValue) => ({
          key,
          value: childValue
        }))
      }
      return result
    }) || []

  return values.flat()
}
